/* eslint-disable max-lines */
import { FormComponentProps } from 'src/components/FormComponents';
import { NAME_FIELD_REGEX } from '../../constants/constants';

export const COVERAGE_DATE_MAX_DAYS_IN_FUTURE = 89;

export const QuoteInformationForm = (
  additionalInterests: boolean,
  landlordName: string,
): FormComponentProps => {
  const form: FormComponentProps = {
    form_id: 'QuoteInformationForm',
    form_name: 'QuoteInformationForm',
    layout: 'labeled',
    formItems: [
      {
        id: 'coverageStart',
        title: 'What is your coverage start date?',
        description:
          'This is the day you want to start your renters insurance coverage.',
        field: {
          key: 'coverageStart',
          type: 'DatePicker',
          rules: {
            required: 'Please Select Coverage Start Date',
          },
          templateOptions: {
            label: 'Coverage Start Date',
            minDate: new Date(),
            maxDate: new Date(
              new Date().setDate(
                new Date().getDate() + COVERAGE_DATE_MAX_DAYS_IN_FUTURE,
              ),
            ),
            endYear: new Date().getFullYear() + 1,
            onChange: () => {},
          },
        },
      },
      {
        id: 'additionalInterests',
        title: 'Would you like your landlord to receive a copy of this policy?',
        description:
          "This allows your property manager to receive notifications about your coverage. If they've partnered with TheGuarantors, they will be notified automatically.",
        field: {
          key: 'additionalInterests',
          type: 'RadioButtonAccordion',
          templateOptions: {
            name: 'additionalInterests',
            onShowContent: 'yes',
            defaultSelectedOptions: 'no',
            options: [
              { label: 'Yes', value: 'yes' },
              { label: 'No', value: 'no' },
            ],
            maxLimit: 1,
            items: [
              {
                key: 'firstName',
                type: 'TextInput',
                rules: {
                  required: 'First name is required',
                  maxLength: 50,
                  pattern: NAME_FIELD_REGEX(50),
                },
                templateOptions: {
                  label: 'First Name',
                  inputProps: {
                    maxLength: 50,
                    pattern: NAME_FIELD_REGEX(50),
                  },
                },
                smallSize: true,
              },
              {
                key: 'lastName',
                type: 'TextInput',
                rules: {
                  required: 'Last name is required',
                  maxLength: 50,
                  pattern: NAME_FIELD_REGEX(50),
                },
                templateOptions: {
                  label: 'Last Name',
                  inputProps: {
                    maxLength: 50,
                    pattern: NAME_FIELD_REGEX(50),
                  },
                },
                smallSize: true,
              },
              {
                key: 'email',
                type: 'TextInput',
                rules: {
                  required: 'Email is required',
                },
                templateOptions: {
                  label: 'Email',
                  type: 'email',
                  inputProps: {},
                },
              },
            ],
          },
        },
      },
      {
        id: 'additionalInsuredRoommates',
        title: 'Would you like to add someone to your policy?',
        description:
          'You can add your spouse, partner or roommate(s) to your policy. Please note they must be added to be covered.',
        field: {
          key: 'additionalInsuredRoommates',
          type: 'RadioButtonAccordion',
          templateOptions: {
            name: 'additionalInsuredRoommates',
            onShowContent: 'yes',
            defaultSelectedOptions: 'no',
            options: [
              { label: 'Yes', value: 'yes' },
              { label: 'No', value: 'no' },
            ],
            maxLimit: 7,
            items: [
              {
                key: 'firstName',
                type: 'TextInput',
                rules: {
                  required: 'First name is required',
                  maxLength: 50,
                  pattern: NAME_FIELD_REGEX(50),
                },
                templateOptions: {
                  label: 'First Name',
                  inputProps: {
                    maxLength: 50,
                    pattern: NAME_FIELD_REGEX(50),
                  },
                },
                smallSize: true,
              },
              {
                key: 'lastName',
                type: 'TextInput',
                rules: {
                  required: 'Last name is required',
                  maxLength: 50,
                  pattern: NAME_FIELD_REGEX(50),
                },
                templateOptions: {
                  label: 'Last Name',
                  inputProps: {
                    maxLength: 50,
                    pattern: NAME_FIELD_REGEX(50),
                  },
                },
                smallSize: true,
              },
              {
                key: 'email',
                type: 'TextInput',
                rules: {
                  required: 'Email is required',
                },
                removeButton: true,
                templateOptions: {
                  label: 'Email',
                  type: 'email',
                  inputProps: {},
                },
              },
            ],
          },
        },
      },
    ],
    actionClassName: 'flex-direction-row-reverse',
    actions: [
      {
        label: 'Continue',
        type: 'submit',
        size: 'medium',
      },
    ],
  };

  if (!additionalInterests) {
    form.formItems[1].title = 'Please add your landlord’s contact information.';
    form.formItems[1].field = {
      key: 'additionalInterests',
      type: 'Heading',
      templateOptions: {
        subText: `${landlordName} has already been automatically added as an Interested Party to this Policy. Your landlord will receive a confirmation email once the policy has been purchased.`,
      },
    };
  }
  return form;
};
